import type { ParagraphTwoColsText as ParagraphTwoColsTextData } from "@/lib/api/cms-catalog";
import { ParagraphHeading } from "../shared/ParagraphHeading";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import { Attachments } from "../shared/Attachments";
import styles from "../Paragraph.module.css";

/**
 * Layout 14 — `PARAGRAPH_TWO_COLS_TEXT_LAYOUT`: 2 kolumny tekstu (text | text_1).
 */
export function ParagraphTwoColsText({
  paragraph,
  t,
}: {
  paragraph: ParagraphTwoColsTextData;
  t: ParagraphTranslations;
}) {
  return (
    <section className={styles.paragraph}>
      <ParagraphHeading name={paragraph.name} centerHeader={paragraph.center_header} />
      <div className={styles.colsTwo}>
        <HtmlText html={paragraph.text} />
        <HtmlText html={paragraph.text_1} />
      </div>
      <Attachments files={paragraph.attachments} t={t} />
    </section>
  );
}
